import React from 'react'
import NavBar from '../../components/nav-bar/nav-bar'
import Footer from '../../components/footer/footer'
import PageTitle from '../../components/page-title/page-title'
import Section from '../../components/section/section'
import photoViewCss from './photo-view-css'
import HtmlLink from '../../components/html-link/html-link'

const PhotoView: React.FC = () => {

  return (
    <>
      <NavBar />
      <PageTitle marginTop>Fotografie</PageTitle>
      <p className={photoViewCss.paragraph()}>Pokud by se vám fotografie špatně zobrazovaly v náhledu níže, můžete navštívit přímo
        <HtmlLink href="https://foto.zbiralova.cz/marti-tom/skupinove/">stránky naší fotografky</HtmlLink>.</p>
      <iframe
        src="https://foto.zbiralova.cz/marti-tom/skupinove/"
        title="Wedding photos"
        className={photoViewCss.iframePhotos()}>
      </iframe>

      <PageTitle >Video</PageTitle>
      <Section isBackgroundBlue>
        <div className={photoViewCss.videoWrapper()}>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/US1ngnURud4?si=D8uFuf4DjlPr6QCU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>

        {/* 2. CONTENT - <div>Videa ??</div> */}
      </Section>

      <PageTitle>Fotokoutek</PageTitle>
      <Section isBackgroundBlue>
        <div className={photoViewCss.photoCornerWrapper()}>
          <img src="assets/foto-budka.png" alt="foto-budka" className={photoViewCss.photoCorner()} />

          <div>
            <p>Chceme, aby náš svatební den byl nejen krásný, ale i plný smíchu, vzpomínek a zábavných momentů. Právě proto pro vás bude připraven fotokoutek s rekvizitami.</p>
            <br />
            <p>Fotky si klidně odneste s sebou domů, jako suvenýr z naší svatby.
              Zároveň vás poprosíme, abyste jednu z těch úžasných nebo legračních momentek nalepili do naší svatební knihy, abychom i my měli vzpomínku na vás.
              Pokud připojíte i vzkaz, přání, hlášku nebo třeba vlastní manželskou radu, budeme moc potěšeni.</p>
            <br />
            <p>Děkujeme, že nám pomůžete tímto zachytit atmosféru dne, na který nikdy nechceme zapomenout :)</p>
          </div>
        </div>
      </Section>

      <Footer />
    </>
  )
}

export default PhotoView
